<template>
  <div id="app" class="container-fluid">
    <portal-target name="dash-modal" />
    <PremiumModal />
    <CompanyModal />
    <DashboardModal v-if="!isOnboardingOpen && isModalOpen" />
    <OnboardingModal v-if="isOnboardingOpen" />
    <HoursTimer ref="hours_timer" />
    <div v-if="!loading" class="row topbar-wrapper topbar-wrapper--fixed" :style="'background-color:' + brandingColor + '!important;'">
      <GekkoMenu @toggleChatbot="openChatbot = !openChatbot" />
    </div>
    <div class="row main-row position-relative" :class="[$route.name.toLowerCase()]">
      <LoadingSpinner v-if="loading" />
      <router-view class="w-100 content-wrap" v-if="!loading" :class="[$route.name.toLowerCase()]" @startTimer="$refs.hours_timer.newTimer()" />
    </div>
    <ChatbotSidebar :show="openChatbot" @close="openChatbot = false" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import GekkoMenu from "@/components/GekkoMenu";
import PremiumModal from "@/components/PremiumModal.vue";
import CompanyModal from "@/components/dashboard/CompanyModal";
import HoursTimer from "@/components/hours/HoursTimer.vue";
import DashboardModal from "@/components/dashboard/ui/DashboardModal"
import OnboardingModal from "@/components/OnboardingModal"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import ChatbotSidebar from "@/components/ui/ChatbotSidebar";
 
export default {
  name: "Gekko",
  components: {
    GekkoMenu, 
    PremiumModal, 
    CompanyModal, 
    HoursTimer, 
    DashboardModal, 
    OnboardingModal, 
    LoadingSpinner, 
    ChatbotSidebar
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title + ' - Gekko'
        document.body.classList.remove('modal-on')

        if (this.getCurrentCompany.name != null && !this.getCurrentCompany.name.length && !this.nonBlockingRoutes.includes(to.name)) {
          this.$store.commit('toggleCompanyModal');
        }
      }
    }
  },
  data () {
    return {
      loading: true,
      nonBlockingRoutes: [
        'EditCost',
        'AddCost',
        'AddContact',
        'EditProject',
        'AddProject',
        'EditContact',
        'EditTrip',
        'AddTrip',
        'CostTypes',
        'BalanceSheetEditCost',
        'AddItem',
        'EditItem'
      ],
      openChatbot: false
    }
  },
  computed: {
    ...mapGetters({ 
      isOnboardingOpen: "onboarding/isOnboardingOpen",
      isModalOpen: "dashboard/isModalOpen",
      getCurrentCompany: "main/getCurrentCompany",
      getCurrentUser: "main/getCurrentUser"
    }),
    brandingColor () {
      if (this.getCurrentCompany.accountant_branding)
        return this.getCurrentCompany.accountant_branding.color;
      else
        return "#22AC8A"; // $colorBrand
    },
  },
  created () {
    this.$language.current = window.preferred_language;

    this.loadMainGlobalData().then(() => {
      this.$store.commit('setIsPremium', this.getCurrentCompany.is_premium);
      if (this.getCurrentCompany.name != null && !this.getCurrentCompany.name.length)
        this.$store.commit('toggleCompanyModal');
      this.loading = false
    })

    this.$store.commit('setRoot', this.$root);
  },
  methods: {
    ...mapActions({ 
      loadMainGlobalData: "main/loadMainGlobalData"
    })
  },
};
</script>

<style lang="scss">
.topbar-wrapper {
  &--fixed {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1005;
  }
}
.topbar-wrapper--fixed + .main-row {
  margin-top: $topbarHeight;
  padding-bottom: 4rem;
}
.main-row, .main-row .content-wrap {
  flex-direction: column; flex: 1;
  > .content {
    height: 100%;
    padding: 0 1rem;
    .content--inner {
      border: 1px solid $colorBorderDash;
      border-radius: $radiusLg;
      overflow: hidden;
      overflow-x: auto;
      box-shadow: $contentShadow;
    }
  }
}
@media (max-width: '767px') {
  .main-row, .main-row .content-wrap {
    > .content {
      padding: 0 0.5rem;
    }
  }
}
</style>
